import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { JwtInterceptor } from './main/_intereceptor/jwt.interceptor';
import {MatSidenavModule} from '@angular/material/sidenav';
import { ReqTimeInterceptor } from './main/_intereceptor/req-time.interceptor';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ResolutionsSkeletonModule } from 'src/@mwb/app-skeletons/resolutions-skeleton/resolutions-skeleton.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,    
    ResolutionsSkeletonModule,
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ReqTimeInterceptor,
    multi: true
  }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
